import * as React from "react";
import { connect } from "react-redux";

import Currency from "../../screens/Settings/Currency";
import {
  fetchCurrency,
  AddCurrency,
  EditCurrency,
  DeleteCurrency,
  currencySlectedPage,fetchCoutrys
} from "./action";
class CurrencyContainer extends React.Component<Props, State> {
  render() {
    return (
      <Currency
        fetchCurrency={this.props.fetchCurrency}
        AddCurrency={this.props.AddCurrency}
        CurrencyList={this.props.CurrencyList}
        EditCurrency={this.props.EditCurrency}
        DeleteCurrency={this.props.DeleteCurrency}
        currencySlectedPage={this.props.currencySlectedPage}
        currencyDtlsCount={this.props.currencyDtlsCount}
        fetchCoutrys={this.props.fetchCoutrys}
        CountrysList={this.props.CountrysList}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchCurrency: () => {
      dispatch(fetchCurrency());
    },
    AddCurrency: (value) => {
      dispatch(AddCurrency(value));
    },

    EditCurrency: (value) => {
      dispatch(EditCurrency(value));
    },
    DeleteCurrency: (value) => {
      dispatch(DeleteCurrency(value));
    },
    currencySlectedPage: (value) => {
      dispatch(currencySlectedPage(value));
    },
    fetchCoutrys: () => {
     
      dispatch(fetchCoutrys());
    },
  };
}

const mapStateToProps = (state) => {
  return {
    CurrencyList: state.CurrencyReducer.CurrencyList,
    currencyDtlsCount: state.CurrencyReducer.currencyDtlsCount,
    CountrysList: state.CurrencyReducer.CountrysList,
  };
};

export default connect(mapStateToProps, bindAction)(CurrencyContainer);
